/**
 * AppShell — Layout universel header + sidebar + Outlet
 * Remplace Layout.tsx et AdminShell.tsx
 * Utilise <Outlet /> (React Router v6) — toutes pages sont routes imbriquées
 * Fournit PersonaContext pour les pages utilisant TTS
 * @see NAV-REORG-001 §5.1
 */

import { Outlet } from 'react-router-dom';
import { PersonaProvider } from '@/shared/contexts/PersonaContext';
import { AppHeader } from './AppHeader';
import { FamilySidebar } from './FamilySidebar';

export function AppShell() {
  return (
    <PersonaProvider>
      <div className="min-vh-100 d-flex flex-column">

        <AppHeader />

        <div className="d-flex flex-grow-1" style={{ minHeight: 0 }}>

          <FamilySidebar />

          <main
            className="flex-grow-1 p-4"
            style={{ overflowY: 'auto', minHeight: 0 }}
          >
            <div className="fade-in">
              <Outlet />
            </div>
          </main>

        </div>

        <footer
          className="text-center py-2 border-top text-muted"
          style={{ fontSize: '0.78rem', flexShrink: 0 }}
        >
          Horaliia — Assistant Vocal de Documentation Clinique
        </footer>

      </div>
    </PersonaProvider>
  );
}
